/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { StageService } from './services/stage.service';
import { DepartmentService } from './services/department.service';
import { CategoryService } from './services/category.service';
import { WorkflowService } from './services/workflow.service';
import { DelegateService } from './services/delegate.service';
import { WorkflowInstanceService } from './services/workflow-instance.service';
import { DashBoardService } from './services/dash-board.service';
import { DocumentTypeService } from './services/document-type.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    StageService,
    DepartmentService,
    CategoryService,
    WorkflowService,
    DelegateService,
    WorkflowInstanceService,
    DashBoardService,
    DocumentTypeService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
